import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { css } from '@emotion/react';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 77.125rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  ${mq.large(css`
    flex-direction: row;
  `)}
`;

export const DescriptionWrapper = styled.div`
  width: 100%;
  margin-bottom: 4rem;

  ${mq.large(css`
    width: 50%;
    margin-bottom: 0;
    margin-right: 3.5rem;
  `)}

  ${mq.xLarge(css`
    margin-right: 9rem;
  `)}
`;

export const StickyWrapper = styled.div`
  ${mq.large(css`
    top: 0;
    position: sticky;
    padding-top: 4rem;
  `)}

  ${mq.xLarge(css`
    padding-top: 7.5rem;
  `)}
`;

export const TitleWrapper = styled.h3`
  font-size: 2rem;
  font-weight: 400;
  line-height: 2.5rem;
  margin: 0 0 1.5rem 0;

  ${mq.xLarge(css`
    margin-bottom: 1.5rem;
  `)}
`;

export const TitleComponent = styled.span`
  font-size: 2rem;
  font-weight: 400;
  line-height: 2.5rem;
  margin: 0 0 1.5rem 0;

  ${mq.xLarge(css`
    margin-bottom: 1.5rem;
  `)}
`;

export const Title = styled(TitleComponent)`
  color: #0e4ed7;
`;

export const Subtitle = styled(TitleComponent)`
  color: #000000;
`;

export const Description = styled.p`
  font-family: ${({ theme }) => theme.font.nunito};
  font-size: 1rem;
  font-weight: 300;
  line-height: 2rem;
  color: #000000;
  letter-spacing: 0.0125rem;
  margin: 0;
`;

export const CardsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;

  ${mq.large(css`
    width: 50%;
    align-items: flex-start;
    gap: 3rem;
  `)}
`;

export const Section = styled.section`
  ${defaultContainerSize};
  margin: 0;
  max-width: 100%;

  background: #f4f4f4;
  padding-top: 4rem;
  padding-bottom: 4rem;

  ${mq.xLarge(css`
    padding-bottom: 7.5rem;
    padding-top: 7.5rem;
  `)}
`;
